import { render, staticRenderFns } from "./InputDigitComb.vue?vue&type=template&id=512def40&scoped=true"
import script from "./InputDigitComb.vue?vue&type=script&lang=js"
export * from "./InputDigitComb.vue?vue&type=script&lang=js"
import style0 from "./InputDigitComb.vue?vue&type=style&index=0&id=512def40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512def40",
  null
  
)

export default component.exports